import { useMediaQuery } from 'react-responsive';

export default () =>
  useMediaQuery({
    maxWidth: 1199,
  });
